import React, { useContext } from 'react'
import { Menu as UikitMenu } from '@apeswapfinance/uikit'
import { useWeb3React } from '@web3-react/core'
import { LanguageContext } from 'hooks/LanguageContext'
import useTheme from 'hooks/useTheme'
import { useGetPriceDataFromLP } from 'hooks/useGetPriceData'
import useGetLocalProfile from 'hooks/useGetLocalProfile'
import { injected, bsc, walletconnect } from 'connectors'
import { links, socials } from './config'

const Menu: React.FC = (props) => {
  const { account, activate, deactivate } = useWeb3React()
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext)
  const { isDark, toggleTheme } = useTheme()
  // const priceData = useGetPriceData()
  // const cakePriceUsd = priceData ? Number(priceData.prices.Cake) : undefined
  const lpPrice = useGetPriceDataFromLP()
  const profile = useGetLocalProfile()

  return (
    <UikitMenu
      links={links}
      socials={socials}
      account={account as string}
      login={(connectorId: string) => {
        if (connectorId === 'walletconnect') {
          return activate(walletconnect)
        }

        if (connectorId === 'bsc') {
          return activate(bsc)
        }

        return activate(injected)
      }}
      logout={deactivate}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={selectedLanguage?.code || ''}
      setLang={setSelectedLanguage}
      cakePriceUsd={lpPrice}
      langs={[{code: 'en', language: 'English'}]}
      priceLink="https://poocoin.app/tokens/0xa73c15620bfa79646e9a11d0d638d66588456462"
      {...props}
    />
  )
}

export default Menu
